import { ComplianceAnalysisCardBaseProduct } from "./ComplianceAnalysisCardBaseProduct";
import { routerStore } from "csi/state/rootStore";
import { ComplianceAnalysisSlimOnInstance, DojoViewContext, QueryContext } from "./ComplianceAnalysisSlimOnInstance";

const queryAttr: string = "ParentProduct";
const queryDependencyPath: string = "Child:__Parent__/Child:ParentDataSheetRevision/Child:__Parent__";
const queryPath: string = "Child:__Parent__";
const viewId: string = "ComplianceAnalysisResults";

export const ComplianceAnalysisSlimOnInstanceBaseProduct = () => {
	const { locationType } = routerStore;

	return ComplianceAnalysisSlimOnInstance(
		ComplianceAnalysisCardBaseProduct,
		queryAttr,
		QueryContext.LOCATION_NODE,
		queryPath,
		DojoViewContext.LOCATION_NODE,
		viewId,
		locationType,
		"default",
		false,
		true,
		[queryDependencyPath],
	);
};

export default ComplianceAnalysisSlimOnInstanceBaseProduct;
